import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import '../styles/courses.css';

const Courses = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);

  const glaLogo = "/logo.png";

  useEffect(() => {
    // Mock courses data
    const mockCourses = [
      {
        id: 1,
        title: "Grit 1",
        description: "Learn the basics of HTML, CSS, and JavaScript",
        category: "Technology",
        level: "Beginner",
        duration: 40,
        progress: 65,
        enrolled: true,
        image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=500&h=300&fit=crop"
      },
      {
        id: 2,
        title: "AI AND PRACTICAL APPLICATIONS FOR AFRICA",
        description: "Master advanced React concepts and patterns",
        category: "Technology",
        level: "Advanced",
        duration: 60,
        progress: 30,
        enrolled: true,
        locked: true,
        image: "https://images.unsplash.com/photo-1526374965328-7f5ae4e8a311?w=500&h=300&fit=crop"
      }
    ];

    // Load all courses
    setCourses(mockCourses);
    // Check if user is admin (mock check)
    setIsAdmin(user?.role === 'admin');
  }, [user]);

  const handleCourseClick = (courseId) => {
    navigate(`/course/${courseId}`);
  };

  const handleCreateCourse = () => {
    navigate('/create-course');
  };

  return (
    <div className="page" style={{ display: 'block' }}>
      <div className="container">
        <div className="section-header">
          <h2>Courses</h2>
          {isAdmin && (
            <button 
              className="btn btn-goldenrod" 
              onClick={handleCreateCourse}
              style={{ width: 'auto', padding: '0.625rem 1.25rem' }}
            >
              + New Course
            </button>
          )}
        </div>
        
        <div className="course-grid">
          {courses.map((course) => (
            <div 
              key={course.id} 
              className="course-card" 
              onClick={() => !course.locked && handleCourseClick(course.id)}
              style={{ cursor: course.locked ? 'not-allowed' : 'pointer', display: 'flex', flexDirection: 'column', overflow: 'hidden', opacity: course.locked ? 0.7 : 1 }}
            >
              <div style={{ position: 'relative', height: '180px', overflow: 'hidden', background: 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)' }}>
                <img 
                  src={course.image} 
                  alt={course.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <div style={{ position: 'absolute', top: 'var(--spacing-md)', right: 'var(--spacing-md)', background: 'white', borderRadius: '50%', width: '50px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                  <img 
                    src={glaLogo} 
                    alt="GLA Logo" 
                    style={{ height: '40px', width: 'auto', objectFit: 'contain' }}
                  />
                </div>
              </div>
              <div className="course-card-content">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--spacing-md)' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <h3 className="course-title">{course.title}</h3>
                      {course.locked && <i className="fas fa-lock" style={{ color: '#dc3545', fontSize: '1.8rem' }}></i>}
                    </div>
                    <p className="course-description">{course.description}</p>
                  </div>
                  <button 
                    className="engage-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      !course.locked && handleCourseClick(course.id);
                    }}
                    title={course.locked ? "This course is locked" : "View course details"}
                    disabled={course.locked}
                    style={{ marginLeft: 'var(--spacing-md)', opacity: course.locked ? 0.5 : 1, cursor: course.locked ? 'not-allowed' : 'pointer' }}
                  >
                    <i className="fas fa-arrow-right"></i>
                  </button>
                </div>
                <div className="course-meta">
                  <span className="badge">{course.level}</span>
                  <span className="badge">{course.duration}h</span>
                </div>
              </div>
              <div className="course-card-footer">
                <div className="course-progress-section">
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${course.progress}%` }}></div>
                  </div>
                  <div className="progress-text">{course.progress}% Complete</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Courses;
